$(function(){

	// console.log('nav is ready');

	$(".nav li").hover( function(){
		$(this).addClass("over");
	},function(){
		$(this).removeClass("over");
	});

	// Mobile Nav
	
	var openNav = $('.open_nav'),
		nav = $('nav'),
		subNav = $('.subnav'),
		touchDevice = (function () {
			return "ontouchstart" in window || "onmsgesturechange" in window
		})();
		
	openNav.click(function() {
  	return nav.stop().slideToggle(500), !1
	}), subNav.prev().on({
	  touchstart: function() {
	    var e = $(this).parent(),
	      a = e.hasClass("active");
	    if (!touchDevice || a) return !0;
	    $(".active").removeClass("active"), nav.find("li").removeClass("over");
	    for (var s = e.parents(), t = 0; t < s.length; t++) $(s[t]).is("li") && $(s[t]).addClass("over");
	    e.addClass("active over")
	  }
	});

	$('.hamburger').click(function(){
		$(this).toggleClass('is-active');
	});
	if ( $('.open_nav').is(':visible') == true ){
		$('.showSub').on('click', function(){
			$(this).parent('li').first().children('ul').slideToggle(200);
			$(this).toggleClass('open');
			$(this).parent('li').toggleClass('open');
			subNav.click(() => {
				$(this).parent('li').first().children('ul').slideUp(200);
				$(this).toggleClass('open');
				$(this).parent('li').toggleClass('open');
				nav.stop().slideUp(500)
				$('.hamburger').removeClass('is-active')
				console.log("as")
			})
		});
		
	};
	

});
